import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ConstructionTechnical = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="construction-technical"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.9993 10.0262C21.7703 9.79724 21.3995 9.79724 21.1705 10.0262C20.9418 10.2549 20.5703 10.2549 20.3416 10.0262C20.1129 9.79759 20.1129 9.42604 20.3416 9.19739L17.0261 12.5129C17.2548 12.2842 17.6263 12.2842 17.855 12.5129C18.0836 12.7415 18.0836 13.1131 17.855 13.3417C17.6259 13.5708 17.6259 13.9416 17.855 14.1707L18.6838 14.9995C18.9129 15.2286 19.2837 15.2286 19.5128 14.9995L22.8283 11.6841C23.0573 11.455 23.0573 11.0842 22.8283 10.8552L21.9993 10.0262Z" />
      <path d="M14.1252 8.78294L16.6117 11.2695L19.5128 8.36845C19.7418 8.13937 19.7418 7.7686 19.5128 7.5396L17.855 5.88184C15.6594 3.68628 12.129 2.49032 9.56637 5.05298C9.39882 5.22052 9.34822 5.47266 9.4393 5.69159C9.52823 5.90809 9.74149 6.05345 9.98074 6.05345C12.9959 6.05345 14.8625 7.86254 14.8795 7.87949C14.9204 7.9204 14.9204 7.98761 14.8795 8.02844L14.1252 8.78294Z" />
      <path d="M3.51415 21.8804C4.19977 22.566 5.31515 22.566 6.00077 21.8804L15.7828 12.0984L13.2962 9.61182L3.51415 19.3939C2.82862 20.0794 2.82862 21.1949 3.51415 21.8804Z" />
    </svg>
  );
};
/* eslint-enable max-len */

ConstructionTechnical.defaultProps = {
  className: null,
};

ConstructionTechnical.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ConstructionTechnical;
